module.exports = __webpack_public_path__ + "img/38ne.2162c832.svg";